/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const normalizeLoqateFindResponse = (response = {}) => {
    const items = Array.isArray(response.Items) ? response.Items : [];

    return {
        count: items.length,
        results: items.map((item, index) => ({
            id: item.Id || `loqate-item-${index}`,
            global_address_key: item.Id,
            suggestion: [item.Text, item.Description]
                .filter(Boolean)
                .join(', '),
            text: item.Text || '',
            description: item.Description || '',
            type: item.Type || '',
            highlight: item.Highlight || '',
            isContainer: item.Type === 'Container',
            raw: item,
        })),
    };
};

export default normalizeLoqateFindResponse;
